import React, { createContext, ReactNode, useContext, useState } from "react";

interface IRedraftClauseContext {
  query: string;
  setQuery: React.Dispatch<React.SetStateAction<string>>;
  loadingRewriting: boolean;
  setLoadingRewriting: React.Dispatch<React.SetStateAction<boolean>>;
  queryReply: string;
  setQueryReply: React.Dispatch<React.SetStateAction<string>>;
  selectedTextError: string;
  setSelectedTextError: React.Dispatch<React.SetStateAction<string>>;
  madeRequest: boolean;
  setMadeRequest: React.Dispatch<React.SetStateAction<boolean>>;
  loadingInsertion: boolean;
  setLoadingInsertion: React.Dispatch<React.SetStateAction<boolean>>;
}

const RedraftClauseContext = createContext<IRedraftClauseContext | null>(null);

export const RedraftClauseProvider = ({ children }: { children: ReactNode }) => {
  const [query, setQuery] = useState("");
  const [loadingRewriting, setLoadingRewriting] = useState(false);
  const [queryReply, setQueryReply] = useState("");
  const [selectedTextError, setSelectedTextError] = useState("");
  const [madeRequest, setMadeRequest] = useState(false);
  const [loadingInsertion, setLoadingInsertion] = useState(false);

  return (
    <RedraftClauseContext.Provider
      value={{
        query,
        setQuery,
        loadingRewriting,
        setLoadingRewriting,
        queryReply,
        setQueryReply,
        selectedTextError,
        setSelectedTextError,
        loadingInsertion,
        setLoadingInsertion,
        madeRequest,
        setMadeRequest,
      }}
    >
      {children}
    </RedraftClauseContext.Provider>
  );
};

export const useRedraftClause = () => {
  const context = useContext(RedraftClauseContext);
  if (!context) {
    throw new Error("useRedraftClause must be used within a RedraftClauseProvider");
  }

  return context;
};
